<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="getProductList('search')">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content common-search-formtype">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="产品类型：">
              <el-select v-model="searchDataObj.productQuery.product_types" clearable placeholder="请选择产品类型">
                <el-option v-for="item in productTypeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品名称：">
              <el-input @keyup.enter.native="searchData" v-model.trim="searchDataObj.productQuery.product_name"
                placeholder="请输入产品名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="产品编码：">
              <el-input @keyup.enter.native="searchData" v-model.trim="searchDataObj.productQuery.product_code"
                placeholder="请输入产品编码" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">产品列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-popover class="aud-pop-con" placement="bottom-end" width="580" v-model="visible2">
          <div style="margin-top: 10px;max-height: 290px;" :class="rowData.length >= 25 ? 'scroll-pop' : ''">
            <div style="text-align: right;margin-right: 10px;margin-top: -5px;">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllAttr" @change="handleCheckAllChange">
                全选
              </el-checkbox>
            </div>
            <el-checkbox-group class="aud-popover" @change="handleCheckedAttrChange" v-model="checkedRowData" :min="1"
              :max="100000">
              <draggable class="list-group" :list="rowData" @change="log">
                <span class="aud-pop-span" v-for="(item, index) in rowData" :key="index">
                  <img class="pop-img" src="/static/img/line.png" />
                  <el-checkbox :label="item.identity">
                    {{ item.name }}
                  </el-checkbox>
                </span>
              </draggable>
            </el-checkbox-group>
          </div>
          <div class="aud-pop-btn-content">
            <el-button class="btn-cancel" size="mini" @click="visible2 = false">取 消</el-button>
            <el-button class="btn-confirm" type="primary" size="mini" @click="setRowList">确定</el-button>
          </div>

          <el-button class="add-btn btn-right set-columns" v-show="btnType.set_column" type="primary" slot="reference">
            设置列
          </el-button>
        </el-popover>
        <el-button type="primary" v-show="btnType.add" @click="toAddProduct('add')" class="add-btn btn-right" style="float: right;">新建
        </el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <!-- 表格 -->
      <el-table @sort-change="sortChange" class="audiences-table-content product-table" v-loading="loadList"
        :data="tableData" border :empty-text="emptyText">
        <template slot="empty">
          <div class="newTableEmpty">暂无数据，去<span @click="toAddProduct('add')">新建</span></div>
        </template>
        <el-table-column :sortable="data.isSort" min-width="160" :label="data.label" v-for="data in headerList"
          :key="data.identity" :prop="data.identity">
          <template slot-scope="scope">
            <img v-if="data.identity == 'avatar'"
              style="width: 32px; height: 32px; display: block; border-radius: 50%; text-align: left; float: left; margin-right: 10px;"
              :src="scope.row[data.identity] | showImgUrl" />
            <div v-else :class="isSafari ? 'aud-show-divs' : 'aud-show-div'">
              <span :title="scope.row[data.identity]">{{ scope.row[data.identity].replace(/ /, '&nbsp;') }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column class="aud-operatopn-div" fixed="right" label="操作" width="160">
          <template slot-scope="scope" v-if="scope.row.id !== ''">
            <div class="op-link">
              <span class="op-link editColor" v-show="btnType.edit" @click="toAddProduct('edit', scope.row)" size="small">编辑</span>
            </div>
            <div class="op-link">
              <span class="op-link deleteColor" v-show="btnType.del" @click="deleteItem(scope.row)" size="small">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-size="limit" :current-page="searchDataObj.page"
          layout="total, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getDashBoardList, addDashBoard, deleteDashboard,butonsList,getMenId } from '@/api/analyse.js'
import { getProductList, getProductModel, getProductModelIdFields, setAudRowList, deleteResourceProduct, getAudListShowSix, getCusAttrList } from '@/api/set.js'
import draggable from 'vuedraggable'
export default {
  name: 'boardList',
  data () {
    //
    return {
      emptyText: '空',
      isIndeterminate: true,
      visible2: false,
      isSafari: false,
      myStorage: window.localStorage,
      options: [],
      rules: {
        name: [
          { required: true, message: '请输入看板名称', trigger: 'blur' }
        ]
      },
      addBoardForm: {
        name: ''
      },
      dialogVisible: false,
      formInlineTmp: {
        createUserName: '',
        name: ''
      },
      formInline: {
        createUserName: '',
        name: ''
      },
      productTypeList: [{
        label: '自有产品',
        value: '自有产品'
      }, {
        label: '第三方产品',
        value: '第三方产品'
      }],
      searchDataObj: {
        page: 1,
        limit: 10,
        productQuery: {
          product_name: '',
          product_code: '',
          product_types: '',
        },
        modelId: '',
        rowList: {
          identity: '',
          name: '',
          sort: '',
          type: '',
          isChecked: 1
        },
        userGroupId: null
      },
      loadList: true,
      headerList: [],
      checkedRowData: [],
      rowData: [],
      modelId: '',
      loading: false,
      hide: true,
      tableData: [],
      // 设置列全选或者取消
      checkedAttr: [],
      checkAllAttr: '',
      totalCount: 0,
      limit: 10,
      page: 1,
      rowList: [],
      isSwitchClick: 1,
      memberLevelList: [],
      btnType:{
        'add':false,
        'edit':false,
        'del':false,
        'set_column':false
      }
    }
  },
  methods: {
    // 添加编辑
    toAddProduct (type, row) {
      let code = ''
      if (type === 'add') {
        code = ''
      } else {
        code = row.id
      }
      localStorage.setItem('currentPage', this.searchDataObj.page)
      router.push({ path: '/home/product-add', query: { modelId: this.modelId, code: code, row: row, type: type } })
    },
    queryBtnList(){
      var itemId = getMenId(this.$route.path)
       butonsList({systemCode: 'ZY_INTELLIQUOR',menuId:itemId})
        .then((res)=>{
          if(res.data.code == '200'){
            var btnList = this.btnType
            for(let i = 0, k = res.data.result.length; i < k; i ++){
              for(let m in btnList){
                if(res.data.result[i].perms.indexOf(m) != -1){
                  this.btnType[m] = true
                }
              }
            }
          }
        })
    },
    // 排序
    sortChange (val) {
      if (val.order === 'ascending') {
        this.getAsc(val.prop)
      }
      if (val.order === 'descending') {
        this.getDesc(val.prop)
      }
      if (val.order === null) {
        for (let one of this.rowList) {
          one.sortRole = ''
        }
        this.getProductList()
      }
    },
    // 降序
    getDesc (identity) {
      for (let one of this.rowList) {
        one.sortRole = ''
        if (one.identity === identity) {
          one.sortRole = 'desc'
        }
      }
      this.getProductList()
    },
    handleCheckAllChange (val) {
      this.checkedRowData = val ? this.checkedAttr : []
      this.isIndeterminate = false
    },
    handleCheckedAttrChange (value) {
      this.checkedRowData = value
      let checkedCount = value.length
      this.checkAllAttr = checkedCount === this.checkedAttr.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkedAttr.length
    },
    // 设置列拖拽排序
    log (evt) {
      window.console.log(evt)
      let arr = []
    },
    // 设置列
    setRowList () {
      if (this.checkedRowData.length === 0) {
        _g.toastMsg('error', '请选择列')
        return
      }
      let modelId = this.modelId
      this.rowList = []
      let rowDatas = JSON.parse(JSON.stringify(this.rowData))
      for (let i in rowDatas) {
        for (let one of this.checkedRowData) {
          if (one === rowDatas[i].identity) {
            rowDatas[i].isChecked = 1
            rowDatas[i].sort = i
            break
          } else {
            rowDatas[i].isChecked = 0
          }
        }
      }
      setAudRowList(modelId, JSON.stringify(rowDatas)).then((res) => {
        if (res.data.code == 200) {
          _g.toastMsg('success', '设置列成功')
          this.loadList = true
          this.loadSix()
          this.visible2 = false
        } else {
          _g.toastMsg('error', res.data.message)
          this.loadSix()
          this.visible2 = false
        }
      })
    },
    // 加载属性取前六个的列表（常用）
    loadSix (modelId) {
      if (!modelId) {
        modelId = this.modelId
      }
      this.rowList = []
      this.headerList = []
      getAudListShowSix(modelId).then((audListShowSixRes) => {
        if (audListShowSixRes.data.code == 200) {
          getCusAttrList(modelId).then((res) => {
            if (res.data.code == 200) {
              let data = res.data.result
              let normal = []
              let notNormal = []
              for (let attr of data) {
                if (attr.isNormal === 0) {
                  notNormal.push(attr)
                } else {
                  normal.push(attr)
                }
              }
              // 总的设置列属性
              this.rowData = []
              let arr = JSON.parse(audListShowSixRes.data.result.fields)
              for (let a of arr) {
                for (let item of normal) {
                  if (item.identity === a.identity) {
                    a.name = item.name
                  }
                }
              }
              // 处理设置列选中
              this.checkedRowData = []
              // 处理发给后台的表头
              this.rowData = arr
              let checkedAttr = []
              for (let item of this.rowData) {
                checkedAttr.push(item.identity)
              }
              this.checkedAttr = checkedAttr
              for (let one of arr) {
                if (one.isChecked === 1) {
                  this.rowList.push(one)
                  this.checkedRowData.push(one.identity)
                }
              }
              // console.log(this.checkedRowData, '选中的值')
              this.checkAllAttr = this.checkedRowData.length === this.checkedAttr.length
              this.isIndeterminate = this.checkedRowData.length > 0 && this.checkedRowData.length < this.checkedAttr.length
              this.getProductList(modelId)
            }
          })
        }
      })
    },
    // 获取产品modelid
    getProductModel () {
      getProductModel(52).then(res => {
        this.modelId = res.data.result[0].id
        // 获取产品模型展示列
        this.getProductModelIdFields(this.modelId)
      })
    },
    getProductModelIdFields (modelId) {
      getProductModelIdFields(modelId).then(res => {
        // 获取产品模型展示列
        if (res.data.code == 200) {
          let data = res.data.result
          let normal = []
          let notNormal = []
          // for (let attr of data) {
          //   if (attr.isNormal === 0) {
          //     notNormal.push(attr)
          //   } else {
          //     normal.push(attr)
          //   }
          // }
          // 总的设置列属性
          this.rowData = []
          let arr = JSON.parse(res.data.result.fields)
          for (let a of arr) {
            for (let item of normal) {
              if (item.identity === a.identity) {
                a.name = item.name
              }
            }
          }
          // 处理设置列选中
          this.checkedRowData = []
          // 处理发给后台的表头
          this.rowData = arr
          let checkedAttr = []
          for (let item of this.rowData) {
            checkedAttr.push(item.identity)
          }
          this.checkedAttr = checkedAttr
          for (let one of arr) {
            if (one.isChecked === 1) {
              this.rowList.push(one)
              this.checkedRowData.push(one.identity)
            }
          }
          // console.log(this.checkedRowData, '选中的值')
          this.checkAllAttr = this.checkedRowData.length === this.checkedAttr.length
          this.isIndeterminate = this.checkedRowData.length > 0 && this.checkedRowData.length < this.checkedAttr.length
          this.getProductList()
          this.loadSix()
        }
      })
    },
    // 获取产品模型展示列
    deleteItem (row) {
      let that = this
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteResourceProduct(row.id)
      }).catch(() => {
      })
    },
    // 删除数据
    deleteResourceProduct (id) {
      deleteResourceProduct(this.modelId, id).then(res => {
        if (res.data.code == 200) {
          this.getProductList()
          _g.toastMsg('success', '删除成功')
        }
      })
    },
    // 获取产品列表
    getProductList (type) {
      let that = this
      if (type == 'search') {
        this.searchDataObj.page = 1
      }
      this.loadList = true
      let newRowList = []
      this.rowList.map(function (item, index) {
        // 应国台要求，增加排序处理
        if (item.isChecked === 1 || item.identity == 'data_sort') {
          if(item.identity == 'data_sort'){
            item.sortRole = 'desc'
          }
          newRowList.push(item)
        }
      })
      this.searchDataObj.rowList = newRowList
      this.searchDataObj.modelId = this.modelId
      getProductList(this.searchDataObj).then(res => {
        that.loadList = false
        if (res.data.code == 200) {
          for (let one of res.data.result.header) {
            if (one.type === 'number' || one.type === 'datePicker' || one.type === 'dateTimePicker') {
              one.isSort = 'custom'
            }
          }
          for (let child of res.data.result.list) {
            if (child.sys_create_time === '1970-01-01 08:00:00') {
              child.sys_create_time = ''
            }
            if (child.birthday === '1900-01-01') {
              child.birthday = ''
            }
          }
          this.headerList = res.data.result.header
          let list = res.data.result.list || []
          list.forEach(item => {
            for (const key in item) {
              if (item[key] === '' || item[key] === null || item[key] === undefined || item[key] === 'null' || item[key] === 'undefined') {
                item[key] = '--'
              }
            }
          })
          this.tableData = list
          this.totalCount = res.data.result.total
          setTimeout(function () {
            that.loadList = false
          }, 100)
        } else {
          that.loadList = false
          this.handleInitList()
        }
      })
    },
    handleInitList () {
      this.loadList = false
      this.isHight = false
      this.headerList = []
      this.tableData = []
      this.totalCount = 0
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addDashBoardAction()
        } else {
          return false
        }
      })
    },
    addDashBoardAction () {
      addDashBoard(this.addBoardForm.name).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.des)
          this.dialogVisible = false
          this.getData()
        } else {
          _g.toastMsg('error', res.data.des)
        }
      })
    },
    handleChange () { },
    searchData () {
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.page = 1
      this.getData()
    },
    switchChange (row, status) {
      if (this.isSwitchClick === 1) {
        this.isSwitchClick = 0
        this.$nextTick(() => {
          changeNoticeStatus(row.id, status).then((res) => {
            if (res.data.code === 0) {
              _g.toastMsg('success', res.data.error)
            } else {
              _g.toastMsg('error', res.data.error)
            }
            this.isSwitchClick = 1
            this.getData()
          })
        })
      }
    },
    pushToDashBoardPage (item) {
      let layoutArr = []
      let resultArray = []
      this.myStorage.setItem('boardName', item.name)
      this.myStorage.setItem('itemFigures', JSON.stringify(item.figures))
      for (var j = 0; j < item.figures.length; j++) {
        if (item.figures[j].position !== '') {
          let arr = JSON.parse(item.figures[j].position)
          let type = item.figures[j].showType
          layoutArr.push({
            'x': arr[0],
            'y': arr[1],
            'w': arr[2],
            'h': arr[3],
            'i': JSON.parse(item.figures[j].id),
            'showType': type,
            'type': item.figures[j].type,
            'name': item.figures[j].name
          })
        } else {
          layoutArr.push({
            'x': 0,
            'y': 0,
            'w': 6,
            'h': 9,
            'i': JSON.parse(item.figures[j].id),
            'showType': '',
            'type': item.figures[j].type,
            'name': item.figures[j].name
          })
        }
      }
      this.myStorage.setItem('itemLayout', JSON.stringify(layoutArr))
      this.myStorage.setItem('dashBoardId', item.id)
      router.push({ path: '/home/board-list' })
    },
    // 处理分页
    handleSizeChange (val) {
      this.searchDataObj.limit = val
      this.getProductList()
    },
    handleCurrentChange (page) {
      this.searchDataObj.page = page
      this.getProductList()
    },
    getData () {
      this.loading = true
      getDashBoardList(this.page, this.limit, this.formInline.name, this.formInline.createUserName).then(res => {
        if (res.data.code === 0) {
          this.totalCount = res.data.data.total
          this.tableData = res.data.data.data
        } else {
          _g.toastMsg('error', res.data.des)
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created () {
    if (localStorage.getItem('currentPage') !== '0' && localStorage.getItem('currentPage') !== null) {
      this.searchDataObj.page = parseInt(localStorage.getItem('currentPage'))
    }
    this.getProductModel()
    this.queryBtnList()
    // this.getData()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #e4e4e4;
  height: 60px;
  padding: 10px;
  line-height: 40px;
  margin-top: 10px;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.enable-button {
  color: #1980ff;
  cursor: pointer;
  font-size: 14px;
}
.right {
  width: 370px;
}
</style>
